// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"27ff67bd","255":"c2f855fb","347":"83715df5","473":"990eb3df"}[chunkId] + ".chunk.js";
};